import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/footer';
import ErrorBoundary from './components/errorBoundary';
import Loading from './components/loading';
import ScrollToTop from './components/scrollToTop';
import CursorTrail from './components/cursorTrail';
import CanvasBackground from './components/canvasBackground';
import { ThemeProvider } from './hooks/useTheme';

const Home = lazy(() => import('./pages/Home'));
const ProjectDetailsPage = lazy(() => import('./pages/ProjectDetailsPage'));
const NotFound = lazy(() => import('./pages/NotFound'));

const App = () => {
  return (
    <ThemeProvider>
      <CanvasBackground />
      <CursorTrail />
      <div className="app-shell">
        <ErrorBoundary>
          <Router>
            <ScrollToTop />
            <div className="app-shell-content flex min-h-screen flex-col">
              <main className="flex-1">
                <Suspense fallback={<Loading fullScreen />}>
                  <Routes>
                    <Route path="/" element={<Home />} index />
                    <Route path="/project/:title" element={<ProjectDetailsPage />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </main>
              <Footer />
            </div>
          </Router>
        </ErrorBoundary>
      </div>
    </ThemeProvider>
  );
};

export default App;
